// extracted by mini-css-extract-plugin
export default {"list":"Categories_list__wSpNW","mobList":"Categories_mobList__BJgYv","formattedLastUpdate":"Categories_formattedLastUpdate__fVH+f"};